import { isParsable, safeDecodeURI } from '@pioz/mlm-common';
import { RichtextEditor } from '../richtext';

export function TranslationText({ text, className }: { text?: string; className?: string }) {
  if (!text) {
    return null;
  }

  const decodedText = safeDecodeURI(text);

  if (isParsable(decodedText)) {
    return (
      <div className={className}>
        <RichtextEditor readOnly initialValues={JSON.parse(decodedText)} />
      </div>
    );
  }

  return <span className={className}>{decodedText}</span>;
}
